export default "#version 300 es\n\nin vec3 aPos;\n\nout vec2 vLocalPos;\n\nvoid main(void) {\n    vLocalPos = aPos.xy;\n    gl_Position = vec4(aPos, 1.0);\n}"